import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getPaymentCreationState } from "../redux/paymentSelectors";
import { getPaymentById } from "../../../Redux/Selectors/paymentSelector";
import { transactionPaymentCreateRequest } from "../redux/paymentActions";
import { PAYMENT_METHOD_LABELS } from "../PaymentMethods";
import { cardStatus } from "../utils";

const FiservPaymentScreen = ({ transactionId, amount, currency, onFinish }) => {
  const { t } = useTranslation("result");
  const dispatch = useDispatch();
  // El estado de creación es compartido entre medios: solo se toma en cuenta
  // después de ver arrancar el request de esta pantalla
  const requestStarted = useRef(false);
  const {
    paymentId,
    loading: paymentCreationLoading,
    error: paymentCreationError,
    success: paymentCreationSuccess,
  } = useSelector(getPaymentCreationState, shallowEqual);
  const payment = useSelector((state) => getPaymentById(state, paymentId));

  useEffect(() => {
    dispatch(
      transactionPaymentCreateRequest({
        provider: PAYMENT_METHOD_LABELS.fiserv,
        amount,
        currency,
        transactionId,
      })
    );
  }, []);

  useEffect(() => {
    if (paymentCreationLoading) {
      requestStarted.current = true;
      return;
    }
    if (!requestStarted.current) {
      return;
    }
    if (paymentCreationSuccess && payment?.checkoutUrl) {
      window.location.href = payment.checkoutUrl;
    } else if (paymentCreationError) {
      onFinish({
        type: cardStatus.ERROR,
        content: t("paymentCreationErrorDescription"),
      });
    }
  }, [
    payment,
    paymentCreationLoading,
    paymentCreationSuccess,
    paymentCreationError,
  ]);

  return <></>;
};

FiservPaymentScreen.propTypes = {
  transactionId: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  onFinish: PropTypes.func.isRequired,
};

export default FiservPaymentScreen;
